import React, { FC } from 'react'
import classNames from 'classnames'
import text from 'styles/utility/text.module.scss'
import { Spacer } from 'components/Utility'
import { ScheduleType } from 'types/schedule'
import useDaysOfWeekName from 'hooks/bread/useDaysOfWeekName'
import { parseDateToDeadline, parseTimeToDeadline } from 'lib/helper'

type Props = {
  schedule: ScheduleType
}

const HoursToDeadlineDetailCard: FC<Props> = (props) => {
  const { schedule } = props
  const daysOfWeekName = useDaysOfWeekName(schedule)
  const deadlineDate = parseDateToDeadline(schedule.hours_to_deadline)
  const deadlineTime = parseTimeToDeadline(schedule.hours_to_deadline)
  return (
    <React.Fragment key={schedule.schedule_ref?.id}>
      <p className={classNames(text.font_small, text.font_bold)}>{daysOfWeekName}</p>
      <Spacer size={8} />
      {deadlineDate === '0' ? '当日' : `${deadlineDate}日前`}&nbsp;{deadlineTime}
    </React.Fragment>
  )
}

export default HoursToDeadlineDetailCard
